import { createAPIInstance, createHttpMethods } from '@repo/services/api';
import { signOut } from 'firebase/auth';

import { clearAuthToken } from 'utils/auth';

import { auth } from './firebase';

const affiliateBaseURL = import.meta.env.VITE_APP_IS_MOCKING
  ? 'http://localhost:3002'
  : import.meta.env.VITE_APP_API_BASE_URL;

const cookieDomain = import.meta.env.VITE_APP_COOKIE_DOMAIN;

const axiosInstance = createAPIInstance(
  {
    useLoading: false,
    useToken: true,
    // useToken: false,
    baseURL: affiliateBaseURL,
    useErrorToast: true,
    useRedirectAndLogout: false,
  },
  auth,
  cookieDomain
);

axiosInstance.interceptors.response.use(undefined, (error) => {
  if (error.response?.status === 401) {
    // 과거 오타 env(VITE_COOKIE_DOMAIN)로 domain=undefined 가 되어 쿠키가 실제로 삭제되지 않던 버그를
    // clearAuthToken 으로 대체. 현재/상위 도메인 전체에서 auth_token 을 제거한다.
    clearAuthToken();
    signOut(auth);
    localStorage.removeItem('isCustomLogin');
  }
  throw error;
});

const http = createHttpMethods(axiosInstance);

export default http;
export { axiosInstance };
